/* eslint-disable */

/** Reasons why a payment was prevented from being deposited into a customer's balance. */
export enum RecipientBalanceDenialReason {
  /** MAX_LIMIT - The payment would have caused the customer's balance to exceed the maximum limit. */
  MAX_LIMIT = "MAX_LIMIT",
  /** RISK - Risk determined that the payment is not allowed to be deposited into the balance. */
  RISK = "RISK",
  /**
   * COMPLIANCE - Compliance requirements have changed for sender and therefore we cannot send this payment
   * into the balance.
   */
  COMPLIANCE = "COMPLIANCE",
}
